module.exports = __webpack_public_path__ + "media/country_flags/gb-16f70cd3.png";